import { FormField, Select } from '@amzn/awsui-components-react-v3';
import { ActivityLMSType, ActivityViltType } from '../../Common/Common';
import { ActivityData } from '../../../../interfaces/activity';
import { useEffect, useState } from 'react';
import { SelectProps } from '@amzn/awsui-components-react-v3';

const OPTIONAL_DESCRIPTION =
    'This is a read only field. Selecting a LMS type will set this value.';

export type ViltTypeValues =
    | ActivityViltType.Necto
    | ActivityViltType.WebEx
    | ActivityViltType.Other;

interface ViltTypeOption extends SelectProps.Option {
    readonly label: ViltTypeValues;
    readonly value: string;
}

interface SelectVILTTypeProps {
    handleFieldEvent: (values: Partial<ActivityData>) => void;
    formValues: {
        lms_type: string;
        v_ilt_type?: string | null;
        classrooms_arn?: string | null;
        classrooms_status?: string | null;
    };
    errors: {
        lms_type: string;
        v_ilt_type: string;
        classrooms_arn?: string;
        classrooms_status?: string;
    };
    isDisabled?: boolean;
}

const SelectVILTType = ({
    handleFieldEvent,
    formValues,
    errors,
    isDisabled = false,
}: SelectVILTTypeProps) => {
    const disablevILTTypeEdit = (
        classrooms_arn: string,
        classrooms_status: string,
    ): boolean => {
        return !!classrooms_arn && !!classrooms_status;
    };

    const getOptionsList = () => {
        let options: SelectProps.Option[] = [];
        const lmsType = formValues.lms_type;

        if (
            lmsType === ActivityLMSType.Kiku ||
            lmsType === ActivityLMSType.SkillBuilder
        ) {
            options = [
                {
                    value: ActivityViltType.WebEx,
                    label: ActivityViltType.WebEx,
                },
            ];
        }

        if (lmsType === ActivityLMSType.MyClass) {
            options = [
                {
                    value: ActivityViltType.WebEx,
                    label: ActivityViltType.WebEx,
                },
                {
                    value: ActivityViltType.Other,
                    label: ActivityViltType.Other,
                },
            ];
        }

        if (lmsType === ActivityLMSType.CustomerLMS) {
            options = [
                {
                    value: ActivityViltType.WebEx,
                    label: ActivityViltType.WebEx,
                },
            ];
        }
        return options;
    };

    const [viltTypeOptions, setViltOptions] = useState(getOptionsList());

    const viltTypeOptionsLookup = viltTypeOptions.reduce(
        (acc, opt) => {
            acc[opt.label] = opt;
            return acc;
        },
        {} as {
            [key in ViltTypeValues]: ViltTypeOption;
        },
    );

    useEffect(() => {
        setViltOptions(getOptionsList());
    }, [formValues.v_ilt_type, formValues.lms_type]);
    return (
        <FormField
            label="vILT System Type"
            errorText={errors?.v_ilt_type}
            description={viltTypeOptions.length < 2 ? OPTIONAL_DESCRIPTION : ''}
            data-testid="formField-EditVILTType"
        >
            <Select
                options={viltTypeOptions}
                placeholder="Select vILT System Type"
                selectedOption={
                    formValues.v_ilt_type
                        ? viltTypeOptionsLookup[
                              formValues.v_ilt_type as ViltTypeValues
                          ]
                        : null
                }
                onChange={(e) => {
                    handleFieldEvent({
                        v_ilt_type: e.detail.selectedOption.label,
                    });
                }}
                data-testid={`EditVILTType`}
                disabled={
                    isDisabled ||
                    viltTypeOptions.length < 2 ||
                    disablevILTTypeEdit(
                        formValues.classrooms_arn,
                        formValues.classrooms_status,
                    )
                }
            />
        </FormField>
    );
};

export default SelectVILTType;
